// eslint-disable-next-line import/prefer-default-export
export const addShowFieldToAddresses = settings => {
  const addressArray = [...settings.addresses];
  return {
    ...settings,
    addresses: addressArray.map(address => ({
      ...address,
      show: true,
    })),
  };
};
